const urls = {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    AUTH_URL: "auth",
}
export default urls
